import {findIndex, isString} from "lodash";
import Vuelidate from 'vuelidate'
import Vue from "vue";

Vue.use(Vuelidate)

export default {
    methods: {
        /**
         * This function is applicable for {key: key, value: value} type.
         * Compares key with the given array
         *
         * Please note: this function is intentionally developed to be case insensitive. As it does not make sense to have let's say a rule with the name `allowed` as well As `Allowed`.
         *
         * @param currentValue
         * @param haystack
         * @param allowedValue This is particularly useful for edit. Where we want the user allow to update the existing value.
         * @returns {Promise<unknown>}
         */
        async vuelidateIsUniqueForKeyValueType(currentValue, haystack, allowedValue = false) {

            try {
                return await new Promise((resolve, reject) => {

                    if (allowedValue && allowedValue.toLowerCase() === currentValue.toLowerCase()) {
                        resolve(1);
                    } else {
                        (findIndex(haystack, item => item.key.toLowerCase() === currentValue.toLowerCase()) !== -1) ? reject() : resolve(1)
                    }
                })
            } catch (e) {
                return false
            }

        },

        /**
         *
         * The following solution was just wrote and it's not tested yet.
         *
         * This function is applicable for [{key: key, value: {key: key, value: value}}, {key: key, value: {key: key, value: value}}] type.
         *
         * Compares the nested key inside all the value of the objects given in the array
         *
         * Please note: this function is intentionally developed to be case insensitive. As it does not make sense to have let's say a rule with the name `allowed` as well As `Allowed`.
         *
         * @param currentValue
         * @param haystack
         * @param allowedValue This is particularly useful for edit. Where we want the user allow to update the existing value.
         * @returns {Promise<unknown>}
         * */
        async vuelidateIsUniqueForOneLevelNestedKeyValueType(currentValue, haystack, allowedValue = false) {


            try {
                return await new Promise((resolve, reject) => {

                    if (isString(allowedValue) && allowedValue.toLowerCase() === currentValue.toLowerCase()) {
                        resolve(1);
                    } else {
                        let exists = false;

                        haystack.forEach(item => {

                            item.value.forEach(childItem => {
                                (isString(childItem.key) && childItem.key.toLowerCase() === currentValue.toLowerCase()) ? exists = true : '';
                            })

                        });

                        if ( ! exists) {
                            resolve(1);
                        } else {
                            resolve(false)
                        }
                    }
                });
            } catch (e) {

                return false
            }

        },
        /**
         *
         * Please note the comparison made here is case insensitive.
         * Notice that the function is async, you must await when calling.
         *
         * @param currentValue
         * @param haystack
         * @param parentNodeName
         * @param columnToCompare
         * @param allowedValue
         * @returns {Promise<unknown>}
         */
        async vuelidateIsUniqueForTwoLevelNestedCustomColumn(currentValue, haystack, parentNodeName, columnToCompare, allowedValue = false) {

            try {
                return await new Promise((resolve, reject) => {

                    if (isString(allowedValue) && allowedValue.toLowerCase() === currentValue?.toLowerCase()) {
                        resolve(1);
                    } else {

                        let exists = false;

                        haystack.forEach(item => {

                            item.value.forEach(levelOneItem => {

                                // Because, we also have @_internet as none/filtered/open here which we do not want to loop. The @_internet will be of type string
                                if (typeof levelOneItem.value === 'object') {

                                    levelOneItem.value[parentNodeName]?.forEach(levelTwoItem => {
                                        (levelTwoItem.value[columnToCompare]?.toLowerCase() === currentValue?.toLowerCase()) ? exists = true : '';
                                    })
                                }
                            })
                        });

                        if ( ! exists) {
                            resolve(1);
                        } else {
                            resolve(false)
                        }
                    }
                });
            } catch (e) {

                // FIXME: REMOVE THIS
                console.log('in catch', e);

                return false
            }
        }
    }
}
